export const auditLinks = {
    audit: () => '/audit'
};
